import React from 'react';
import Map, { Marker } from 'react-map-gl/maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';

// Free tile style from CartoCDN (no API key needed)
const MAP_STYLE = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';

export function DeploymentWorldMap({ markers = [], className = '', bgColor = '#ffffff', zoom = 0.9, interactive = false }) {
  return (
    <div className={className} style={{ height: '100%', background: bgColor, transition: 'background 0.6s ease', borderRadius: '12px' }}>
      <Map
        initialViewState={{
          longitude: 20,
          latitude: 30,
          zoom,
        }}
        style={{ width: '100%', height: '100%', borderRadius: '12px' }}
        mapStyle={MAP_STYLE}
        interactive={interactive}
        scrollZoom={false}
        attributionControl={false}
      >
        {markers.map((m, i) => (
          <Marker key={i} longitude={m.lng} latitude={m.lat} anchor="center">
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: m.color,
                boxShadow: `0 0 6px ${m.color}`,
                opacity: 0.9,
              }}
            />
          </Marker>
        ))}
      </Map>
    </div>
  );
}
